export const COLORS = {
  MAIN_COLOR: "linear-gradient(212deg, #3A4CE8 0%, #1F2EB4 98.18%)",
  TEXT_WHITE: "#F9FAFB",
};

export const PATTERNS = {
  GENERAL_DATE_FORMAT: "DD MMM YYYY",
  DATE_TIME_FORMAT: "DD MMM YYYY, hh.mm a",
  DATE_FORMAT: "MM/DD/YYYY",
  DECIMAL_NUMBER: /^(\d*\.)?\d+$/,
  INPUT_NUMBER: /^[+-]?(\d+([.]\d*)?(e[+-]?\d+)?|[.]\d+(e[+-]?\d+)?)$/,
  EMAIL_PATTERN:
    /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/,
  DOMAIN_PATTERN:
    /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/,
  IP_PATTERN:
    /^([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])\.([01]?\d\d?|2[0-4]\d|25[0-5])$/,
  PASSWORD_PATTERN: /^.{6,}$/,
  PASSWORD_UPPER: /^(?=.*[A-Z]).{1,}$/,
  PASSWORD_LETTER: /^(?=.*[a-zA-Z]).{1,}$/,
  PASSWORD_LOWER: /^(?=.*[a-z]).{1,}$/,
  PASSWORD_NUMBER: /^(?=.*\d).{1,}$/,
  DATE_PATTERN: /^(([01])\d)\/(([012])\d)\/((19|20)\d{2})$/,
  SECTION_PATTERN: /[A-E][1-9]-[1-9]|[A-E][1-9]/g,
  NUMBER_MAX_LENGTH_64: /^[0-9]{,64}$/,
  NUMBER_MAX_LENGTH_128: /^[0-9]{,128}$/,
  NUMBER_MAX_LENGTH_255: /^[0-9]{,255}$/,
  USER_GROUP_NAME: /^[a-zA-Z0-9_ -]*$/,
  BLANK_SPACES: /[^\s*]/g,
};

export const STORAGE_KEYS = {
  token: "token",
  user: "user",
  referral: "referral",
  email: "email",
};

export const SEND_MESSAGE = {
  SEND_NOW: "sendNow",
  SEND_LATER: "sendLater",
  SAVE_DRAFT: "saveAsDraft",
  SAVE_TEMPLATE: "saveAsTemplate",
  REPEAT_SEND: "repeatSend",
  REPEAT_DAILY: "DAILY",
  REPEAT_WEEKLY: "WEEKLY_ON",
  REPEAT_EVERY_WEEKDAY: "EVERY_WEEKDAY",
  REPEAT_ANNUALY: "YEARLY_ON",
  REPEAT_CUSTOM: "CUSTOM",
  REPEAT_MONTHLY_FOURTH: "repeatMonthlyFourth",
  REPEAT_MONTHLY_LAST: "repeatMonthlyLast",
};

export const PERMISSION_TYPE = {
  FREE_USER: "USER",
  WORKSPACE_ADMIN: "ADMIN",
  WORKSPACE_OPERATOR: "OPERATOR",
  SUPER_ADMIN: "SUPER_ADMIN",
};

export const DEFAULT_HEADERS_COLUMN = [
  "firstName",
  "lastName",
  "email",
  "phoneNumber",
  "profileImage",
  "facebook",
  "instagram",
  "twitter",
  "snapchat",
];
export const DEFAULT_HEADERS_COLUMNS = [
  {
    title: "First Name",
    dataIndex: "firstName",
  },
  {
    title: "Last Name",
    dataIndex: "lastName",
  },
  {
    title: "Mobile Phone",
    dataIndex: "phoneNumber",
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Image",
    dataIndex: "profileImage",
  },
  {
    title: "Facebook",
    dataIndex: "facebook",
  },
  {
    title: "Instagram",
    dataIndex: "instagram",
  },
  {
    title: "Twitter",
    dataIndex: "twitter",
  },
  {
    title: "Snapchat",
    dataIndex: "snapchat",
  },
];

export const SEND_BROADCAST_TYPE = [
  "SEND_NOW",
  "SEND_LATER",
  "DRAFT",
  "REPEAT",
];

export const BROADCAST_TYPE = {
  SEND_NOW: "SEND_NOW",
  SEND_LATER: "SEND_LATER",
  DRAFT: "DRAFT",
  REPEAT: "REPEAT",
  REPEAT_DAILY: "DAILY",
  REPEAT_WEEKLY: "WEEKLY_ON",
  REPEAT_EVERY_WEEKDAY: "EVERY_WEEKDAY",
  REPEAT_ANNUALY: "YEARLY_ON",
  REPEAT_CUSTOM: "CUSTOM",
  REPEAT_MONTHLY_FOURTH: "REPEAT_MONTHLY_FOURTH",
  REPEAT_MONTHLY_LAST: "REPEAT_MONTHLY_LAST",
};

export const CUSTOM_REPEAT_TYPE = {
  DAY: "DAY",
  WEEK: "WEEK",
  MONTH: "MONTH",
  YEAR: "YEAR",
};
